import { render, staticRenderFns } from "./CheckRequest.vue?vue&type=template&id=dd5a485a&scoped=true"
import script from "./CheckRequest.vue?vue&type=script&lang=js"
export * from "./CheckRequest.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/layout/Request.css?vue&type=style&index=0&id=dd5a485a&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5a485a",
  null
  
)

export default component.exports